module.exports = __webpack_public_path__ + "media/main_cards/salary-880b1aa1.svg";